import {
  ModalContent,
  ModalHeader,
  ModalRoot,
  ModalTitle,
  ModalTrigger,
} from '@synoptic/ui-kit/modal/modal.js';
import { ModalStepper } from '@synoptic/ui-kit/modal/modal.tsx';
import { FC, ReactNode, useState } from 'react';
import { CustomStreamForm } from '@/components/streams/stream-form/custom-stream-form/custom-stream-form.tsx';
import { RegularStreamForm } from '@/components/streams/stream-form/regular-stream-form/regular-stream-form.tsx';
import {
  StreamForm,
  StreamFormInputs,
  StreamFormSubmitValues,
} from '@/components/streams/stream-form/stream-form.tsx';
import { StreamPricingType } from './stream-pricing-type.tsx';
import { useUpdateStream } from './use-update-stream.ts';

export type UpdateStreamModalProps = {
  trigger: ReactNode;
  streamId: string;
} & StreamFormInputs;

export const UpdateStreamModal: FC<UpdateStreamModalProps> = ({
  trigger,
  streamId,
  ...initialValues
}) => {
  const [open, onOpenChange] = useState(false);
  const [updateStream] = useUpdateStream(streamId);

  const [step, setStep] = useState<number>(1);

  const onSubmit = async (input: StreamFormSubmitValues) => {
    const { streamType, paidData, customTargetsData, ...updateInput } = input;

    await updateStream({
      ...updateInput,
      customTargetsData: customTargetsData
        ? (({ __typename, ...rest }) => rest)(customTargetsData)
        : undefined,
    });
    onOpenChange(false);
  };

  return (
    <ModalRoot
      open={open}
      onOpenChange={(open) => {
        onOpenChange(open);
        setStep(2);
      }}
    >
      <ModalTrigger asChild>{trigger}</ModalTrigger>
      <ModalContent>
        <ModalHeader>
          <div>
            {!initialValues.paidData ? null : (
              <ModalStepper step={step - 1} totalSteps={2} />
            )}
            <ModalTitle>Edit data stream</ModalTitle>
          </div>
        </ModalHeader>
        <StreamForm
          onSubmit={onSubmit}
          initialValues={initialValues}
          pricingType={
            initialValues.paidData
              ? StreamPricingType.Paid
              : initialValues.packageOnly
                ? StreamPricingType.PackageOnly
                : StreamPricingType.Free
          }
          customStream={!!initialValues.customTargetsData}
        >
          {!initialValues.customTargetsData ? (
            <RegularStreamForm
              step={step}
              setStep={setStep}
              initialValues={initialValues}
              onClose={() => {}}
            />
          ) : (
            <CustomStreamForm
              step={step}
              setStep={setStep}
              onClose={() => {}}
              initialValues={initialValues}
            />
          )}
        </StreamForm>
      </ModalContent>
    </ModalRoot>
  );
};
